import axios from "axios";
export const ApiUrl = 'https://varahisoft-backend.varahisoft.in/varahisoft-backend/v1';
export const GeolocationApiUrl = 'https://api.ipdata.co';
export const APIKey = 'e933d836ee34a5dbe76fc5feefd3432d24a01acb7b3891842d9f9b13';

// --------------------------------

export const chunkArray = (arr, size) => {
  const chunks = [];
  for (let i = 0; i < arr.length; i += size) {
    chunks.push(arr.slice(i, i + size));
  }
  return chunks;
};

// Define getCountries as an async function
export const getIPGeoLocation = async (path) => {
  try {
    await axios.get(`${GeolocationApiUrl}/?api-key=${APIKey}`).then((res) => {
      if (res?.status === 200) {
        const finalData = {
          ...res.data,
          pathVisited: path || "/"
        };
        getVisitorLocation(finalData)
      }
    }).catch((error) => {
      console.error("Error submitting the form:", error);

    }); // Assuming no `values` parameter is required for POST request
  } catch (err) {
    console.debug(":Values from get currencies", err);

  }
};
// Define getCountries as an async function
export const getVisitorLocation = async (value) => {
  try {
    const payload = {
      visitorLocationId: null,
      ip: value?.ip ? value?.ip : 'NA',
      is_eu: value?.is_eu,
      city: value?.city ? value?.city : 'NA',
      region: value?.region ? value?.region : 'NA',
      region_code: value?.region_code ? value?.region_code : 'NA',
      region_type: value?.region_type ? value?.region_type : 'NA',
      country_name: value?.country_name ? value?.country_name : 'NA',
      country_code: value?.country_code ? value?.country_code : 'NA',
      continent_name: value?.continent_name ? value?.continent_name : 'NA',
      continent_code: value?.continent_code ? value?.continent_code : 'NA',
      latitude: value?.latitude ? value?.latitude : 0,
      longitude: value?.longitude ? value?.longitude : 0,
      postal: value?.postal ? value?.postal : 'NA',
      calling_code: value?.calling_code ? value?.calling_code : 'NA',
      flag: value?.flag ? value?.flag : 'NA',
      emoji_flag: value?.emoji_flag ? value?.emoji_flag : "NA",
      emoji_unicode: value?.emoji_unicode ? value?.emoji_unicode : 'NA',
      pathVisited: value?.pathVisited ? value?.pathVisited : 'NA',
    }
    await axios.post(`${ApiUrl}/varahi/visitorlocation`, payload).then((res) => {
      if (res?.status === 200) {
        return value;
      }
    }).catch((error) => {
      console.error("Error submitting the form:", error);

    });
    // console.log('-----------res------>', res)
  } catch (err) {
    console.debug(":Values from get currencies", err);

  }
};

export const ErrorHandle = (error = {}, setToasts, customMessage, type, color) => {
  let customMessageIsArr = Array.isArray(customMessage)
    ? [...customMessage]
    : [customMessage]
  let errorMessage =
    error?.response?.data?.errorDetail?.errors?.uiErrorKey?.length > 0
      ? error?.response?.data?.errorDetail?.errors?.uiErrorKey?.map(
        (errorMessage) => errorMessage?.localMessage
      )
      : customMessageIsArr
  let item = [
    {
      name: errorMessage,
      type: type,
      color: color,
    },
  ]
  setToasts(item)
  setTimeout(() => {
    setToasts(null)
  }, 5000)

  if (
    (error?.response?.data?.errorDetail?.status === 500 ||
      error?.response?.data?.httpStatusCode === 500 ||
      error?.response?.status === 500) &&
    (error?.response?.data?.errorDetail?.developerMessage ===
      'getLastAccessedTime: Session already invalidated' ||
      error?.response?.data?.errorDetail?.developerMessage ===
      'Session object not found ')
  ) {
    window.location.href = '/'
  }

  return ''
}

